<template>
    <div class="gerenciamento-cidades">    
      <g-card class="card-gerenciamento-cidades" :expansivel="true" :comecaFechado="false">
        <template #cabecalho>
          <div class="header-filtros">
            <div class="titulo-filtros-cabecalho"> Impostos </div>
            <div class="header-icons">
              <g-button
              class="trash-box"
              tipo="cinza"
              altura="35px"
              largura="45px"
              icone="icone_lixo.svg"
              tamanhoIcone="15px"
              somenteIcone
              :sombreado="false"
              v-tooltip="'Limpar filtro'"
              @click="limpar"
              />
              <g-button
              class="buscar-button-header-filtro"
              largura="150px"
              icone="icone_lupa.svg"
              negritoTexto
              tamanhoIcone="15px"
              tamanhoTexto="14px"
              altura="35px"
              gap="10px"
              :sombreado="false"
              @click="buscar"
              >
                BUSCAR
              </g-button>
            </div>
          </div>
        </template>
        
        <g-form>
          <div class="gerenciamento-cidades-conteudo espacamento-filtros">
            <div class="filtro-estado">
              <div class="titulo-conteudo-filtros"> Representante </div>
              <PDropDown
              class="representante-input input-label"
              placeholder="Selecione"
              :filter="true"
              :options="ArrayRepresentantes"
              optionLabel="codigoNomeRepresentante"
              optionValue="representanteId"
              @filter="buscarRepresentante($event.value)"
              v-model="representanteSelecionado"
            />
          </div>
            </div>
        </g-form>
  
        <div class="buscar-button-filtro">
          <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="14px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="buscar"
          >
            BUSCAR
          </g-button>
        </div>
      </g-card>
  
      <g-card v-if="RepresentantesImpostos.length <= 0" paddingDefault="1em 0 3em" :temCabecalho="false">
        <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
        <div class="texto-padrao-imagemfundo">
          Verifique os filtros e clique em buscar para exibir os resultados
        </div>
      </g-card>
  
      <g-card v-if="RepresentantesImpostos.length > 0" paddingDefault="0em 0 3em" :temCabecalho="false">
        <g-data-table
        Titulo="Dados do Representante"
        altura="auto"
        :colunas="Colunas"
        :Paginacao="true"
        :valores="RepresentantesImpostos"
        :NumeroLinhas="50"
        :Filtros="Filtro"
        :FiltrosEspecificos="true"
        :rowEditor="true"
        :Editavel="true"
        TextEditar="Alterar o valor do imposto"
        :Imprimivel="false"
        v-on:editar="abrirPopupEdicao"
        >
        </g-data-table>
      </g-card>
  
      <PDialog  :closable="false" :breakpoints="{ '1025px': '90%' }" style="width: 40%; justify-content: center"
      class="gama-popup" v-model:visible="popupEdicao">
        <template #header>
          <div class="titulo-formulario"> Alterar Valores dos Impostos </div>
        </template>
  
        <div class="grupo-formulario espacamento-filtros">
          <div class="titulo-popup-finalizado"> {{ itemSelecionado.nomeRepresentante }}</div>
          <div class="conteudo-grupo-formulario">
            <div class="cidade-tipo-frete">
              <div class="doistextos">
                <div class="frete-fracionado TextoIRISS">
                  <label class="freteFracionado label-checkbox" for="frete-fracionado" > IR (%)</label>
                  <PInputText
                  id="frete-fracionado"
                  :maxlength="4"
                  @keypress="camponumero"
                  v-model="itemSelecionado.valorIRFormatado"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                ></PInputText>                 
                </div>
                <div class="frete-fechado TextoIRISS">
                  <label class="freteFechado label-checkbox" for="frete-fechado"> ISS (%) </label>
                  <PInputText
                  id="frete-fracionado"
                  :maxlength="4"
                  @keypress="camponumero"
                  v-model="itemSelecionado.valorISSFormatado"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                ></PInputText>                   
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <div class="botoes-popup button-popup">
          <div>
            <g-button
            tipo="cinza"
            negritoTexto 
            largura="230px" 
            altura="35px" 
            @click="fecharPopup"
            >
              CANCELAR
            </g-button>
          </div>
          <div>
            <g-button
            negritoTexto
            largura="230px" 
            altura="35px" 
            @click="atualizarInfos"
            >
              ATUALIZAR   
            </g-button>
          </div>
        </div>
      </PDialog>
    </div>
  </template>

<script>
import GerenciamentoImpostos from './GerenciamentoImpostos.js' 
export default GerenciamentoImpostos
</script>

<style scoped>
/* .doistextos{
  margin-bottom: 30px;
} */
.TextoIRISS{
  display: flex;
  margin-bottom: 30px;

}
.cidade-tipo-frete {
  display: flex;
  justify-content: center;
  margin: 15px 0 40px;
}

.titulo-popup-finalizado {
  padding: 10px 0 5px;
  margin: 5px 0 30px;
}

@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-cidades-conteudo {
  display: grid;
  grid-template-columns: 50%;
}

}

@media (min-width:801px) {
.gerenciamento-cidades-conteudo {
  grid-template-columns: 40%;
}

.TextoIRISS{
  display: inline;
  margin-bottom: 10px;
}

.doistextos{
  display: flex;
  gap: 10px
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
